import Menu from './Menu';
import {$body} from '../Constants';

/**
 * Implementation of Menu for MainMenu Navigation
 */
class MainMenu extends Menu {

}

export default (new MainMenu($body.find('.menuMain')));